"use client";

import { Phone, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Questions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1191" id="still-have-questions" className="bg-background text-foreground relative overflow-hidden">
      {}
      

      {}
      

      {}
      
      {}
      
      {}
      <div ref={ref} className="relative z-10 max-w-5xl mx-auto text-center ![padding:65px_64px_65px_64px]" style={{
      transform: isVisible ? "translateY(0)" : "translateY(24px)",
      opacity: isVisible ? 1 : 0,
      transition: "transform 600ms cubic-bezier(0.16, 1, 0.3, 1), opacity 600ms ease-out"
    }}>
        {}
        <p className="font-default uppercase font-bold tracking-[0.2em] text-xs md:text-sm mb-6" style={{
        color: "hsl(22 90% 50%)"
      }}>
          Expert Consultation
        </p>

        {}
        <h1 className="font-default font-bold leading-[1.1] tracking-tighter mb-8" style={{
        fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
        color: "hsl(220 15% 10%)"
      }}>
          <span className="block">STILL HAVE</span>
          <span className="relative inline-block mt-2">
            <span className="relative z-10 px-4">QUESTIONS?</span>
          </span>
        </h1>

        {}
        <p className="font-default font-normal mx-auto max-w-2xl mb-10 md:mb-12" style={{
        fontSize: "clamp(1.125rem, 1.2vw, 1.25rem)",
        lineHeight: 1.6,
        color: "hsl(220 10% 46%)"
      }}>
          Our team of architectural specialists is ready to discuss your project requirements, material specifications, and installation timelines.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto">
          <Button asChild className="font-default font-bold uppercase tracking-wider text-base md:text-lg px-8 py-7 transition-all duration-200" style={{
          backgroundColor: "hsl(22 90% 50%)",
          color: "hsl(0 0% 100%)"
        }}>
            <Link to="/ContactPage">REQUEST QUOTE</Link>
          </Button>

          <Button asChild className="font-default font-bold uppercase tracking-wider text-base md:text-lg px-8 py-7 transition-all duration-200 bg-transparent border-2" style={{
          color: "hsl(220 15% 10%)",
          borderColor: "hsl(220 15% 10%)"
        }}>
            <Link to="tel:+15878884223">
              <Phone className="w-5 h-5" strokeWidth={2} />
              CALL (587) 888-4223
            </Link>
          </Button>
        </div>

        {}
        <p className="font-default font-bold mt-10 text-sm tracking-widest uppercase" style={{
        color: "hsl(220 10% 46%)"
      }}>
          Serving Calgary, Airdrie, Okotoks, Cochrane & Chestermere
        </p>
      </div>
    </section>;
}